<template>
    <ul v-if="trackersDetails.length" class="tags-selected">
        <li v-for="tracker in trackersDetails" :key="tracker.id" :class="{'tags-toggle-view' : tracker.id === 'more' || tracker.id === 'less'}">
            <template v-if="tracker.id === 'more' || tracker.id === 'less'">
                <span @click="toggleViewMode" class="tags-selected__name">{{tracker.name}}</span>
            </template>
            <template v-else>
                <span class="tags-selected__name" :title="tracker.name">{{tracker.name}}</span>
                <span class="tags-selected__remove" @click="unselectTracker(tracker.id)"></span>
            </template>
        </li>
    </ul>
</template>
<script>
    import {mapActions, mapGetters} from "vuex"

    export default {
        name: 'TrackersBubbles',
        data() {
            return {
                shownAllTrackers: false,
                previewCount: 5,
            }
        },
        props: {
            trackers: {
                type: Array,
                required: true,
            },
        },
        mounted() {
            this.fetchFoldersTrackers()
        },
        computed: {
            ...mapGetters(['foldersTrackersList']),
            trackersList() {
                let trackersList = []
                this.foldersTrackersList.forEach(item => {
                    trackersList = trackersList.concat(item[1])
                })

                return trackersList
            },
            trackersDetails() {
                let trackersDetails = this.trackersList.filter(tracker => this.trackers.includes(tracker.id))

                if (trackersDetails.length > this.previewCount) {
                    if (this.shownAllTrackers) {
                        let showMoreObject = {
                            id: 'less',
                            name: 'Show less',
                        }

                        trackersDetails.push(showMoreObject)
                    } else {
                        let trackersDetailsPreview = trackersDetails.slice(0, this.previewCount)

                        let name = 'Show ' + (trackersDetails.length - this.previewCount) + ' more'
                        let showMoreObject = {
                            id: 'more',
                            name: name
                        }

                        trackersDetailsPreview.push(showMoreObject)
                        trackersDetails = trackersDetailsPreview
                    }
                }

                return trackersDetails
            }
        },
        methods: {
            ...mapActions(['fetchFoldersTrackers']),
            toggleViewMode() {
                this.shownAllTrackers = !this.shownAllTrackers
            },
            unselectTracker(trackerId) {
                if (this.trackersDetails.length <= (this.previewCount + 2)) {
                    this.shownAllTrackers = false
                }

                this.$emit('unselectTracker', trackerId)
            }
        },
    };
</script>
